/**
 * @TODO: Move all hard-code campaigns UI copy here
 */
export const content = {
  'designer.campaigns.activate-tab.label': 'Activate',
  'designer.campaigns.campaigns-home-panel.title': 'Campaigns',
  'designer.campaigns.create-campaign.step-title': `Create campaign`,
  'designer.campaigns.create-campaign.form-title': `Describe your campaign`,
  'designer.campaigns.create-campaign.form-subtitle': `Describe who this campaign is for, what you want them to do, and the angle that makes your message
resonate. We'll use these to generate your campaign plan and landing page.`,
  'designer.campaigns.create-campaign.brief-description-placeholder': `e.g., Drive signups for a webinar on AI for demand gen, targeting marketing ops teams doing manual segmentation. Focus on saving them time every week.`,
  'designer.campaigns.create-campaign.brief-assets-description': `Attach a campaign brief, slide deck, or other reference materials.`,
  'designer.campaigns.campaign-brief.step-title': `Review your brief`,
  'designer.campaigns.campaign-brief.review-subtitle': `Here's your first draft. You can revisit anytime as your campaign evolves.`,
  'designer.campaigns.campaign-brief.title': 'Campaign brief',
  'designer.campaigns.campaign-brief.subtitle':
    'Guides strategy and messaging for your campaign and landing page copy. Edit or revisit anytime as your campaign evolves.',
  'designer.campaigns.campaign-brief.heading': 'Campaign brief',
  'designer.campaigns.landing-page-language.group-label':
    'Landing page language',
  'designer.campaigns.page-settings.language-label': 'Language',
  'designer.campaigns.get-started.prompt-placeholder': `Share a short description of your goals, audience, and key messages. This will become a campaign brief that you'll get to review next.`,
  'designer.campaigns.get-started.prompt-attach': 'Attach files',
  'designer.campaigns.get-started.prompt-submit': 'Create campaign',
  'designer.campaigns.get-started.steps-title': 'Steps to launch',
  'designer.campaigns.get-started.steps-scroll-back': 'Scroll steps back',
  'designer.campaigns.get-started.steps-scroll-forward': 'Scroll steps forward',
  'designer.campaigns.get-started.brand.title': 'Set up your brand',
  'designer.campaigns.get-started.brand.description':
    'Build your brand with just a link to your website.',
  'designer.campaigns.get-started.brand.action': 'Edit brand',
  'designer.campaigns.get-started.needs-campaign':
    'Create your first campaign to see this panel.',
  'designer.campaigns.get-started.no-permission':
    "You don't have permission to create campaigns.",
  'designer.campaigns.get-started.campaign.title': 'Create your first campaign',
  'designer.campaigns.get-started.campaign.description':
    'Share your goals and audiences to generate a brief and landing page.',
  'designer.campaigns.get-started.campaign.action': 'Describe campaign',
  'designer.campaigns.get-started.ads.title': 'Generate ads',
  'designer.campaigns.get-started.ads.description':
    'Generate ad assets that match your landing page.',
  'designer.campaigns.get-started.ads.action': 'Go to ads',
  'designer.campaigns.get-started.activate.title': 'Activate',
  'designer.campaigns.get-started.activate.description':
    'Publish your ads with Google Ads.',
  'designer.campaigns.get-started.activate.action': 'Publish ads',
  'designer.campaigns.get-started.tracking.title': 'Set up tracking',
  'designer.campaigns.get-started.tracking.description':
    'Set up your domain and tracking for analytics.',
  'designer.campaigns.get-started.tracking.action': 'Go to tracking',
  'designer.campaigns.switcher.create-new': 'Create new campaign',
  'onboarding.campaigns.brand-extraction.success.title':
    "We've identified {{items}} for your brand.",
  'onboarding.campaigns.brand-extraction.success.color-schemes':
    '4 color schemes',
  'onboarding.campaigns.brand-extraction.success.font-singular': 'font',
  'onboarding.campaigns.brand-extraction.success.font-plural': 'fonts',
  'onboarding.campaigns.brand-extraction.success.logo-singular': 'logo',
  'onboarding.campaigns.brand-extraction.success.logo-plural': 'logos',
  'onboarding.campaigns.brand-extraction.success.edit-later':
    'You can always edit later when you build your campaign landing page.',
  'onboarding.campaigns.brand-extraction.success.matched-font-heading':
    'We matched the heading font to the closest Google Font.',
  'onboarding.campaigns.brand-extraction.success.matched-font-body':
    'We matched the body font to the closest Google Font.',
  'onboarding.campaigns.brand-extraction.success.matched-font-both':
    'We matched the heading and body fonts to the closest Google Fonts.',
  'onboarding.campaigns.brand-extraction.partial.title.missing-colors':
    "Your typography and logos are ready, but we couldn't extract brand colors from your site",
  'onboarding.campaigns.brand-extraction.partial.title.missing-typography':
    "Your brand colors and logos are ready, but we couldn't extract any typography from your site",
  'onboarding.campaigns.brand-extraction.partial.title.missing-logo':
    "Your brand colors and typography are ready, but we couldn't extract a logo from your site",
  'onboarding.campaigns.brand-extraction.partial.title.missing-colors-and-typography':
    "Your logo is ready, but we couldn't extract any typography or brand colors from your site",
  'onboarding.campaigns.brand-extraction.partial.title.missing-colors-and-logo':
    "Your typography is ready, but we couldn't extract any brand colors or logo from your site",
  'onboarding.campaigns.brand-extraction.partial.title.missing-typography-and-logo':
    "Your brand colors are ready, but we couldn't extract any typography or logo from your site",
  'onboarding.campaigns.brand-extraction.partial.message.default':
    'Try a different URL or finish your brand later.',
  'onboarding.campaigns.brand-extraction.partial.message.missing-colors':
    "Choose your own colors or we'll choose some for you.",
  'onboarding.campaigns.brand-extraction.partial.message.missing-logo':
    'Add one manually or skip for now.',
  'onboarding.campaigns.brand-extraction.partial.message.missing-typography':
    'Select your fonts manually or skip for now',
  'onboarding.campaigns.brand-extraction.failure.access-blocked.title':
    "We couldn't access {{urlDisplay}} — the site blocked our request.",
  'onboarding.campaigns.brand-extraction.failure.access-blocked.message':
    'Try a different URL or add your brand details manually.',
  'onboarding.campaigns.brand-extraction.failure.load-error.title':
    "We couldn't load {{urlDisplay}}.",
  'onboarding.campaigns.brand-extraction.failure.load-error.message':
    'Check the URL or try again.',
  'onboarding.campaigns.brand-extraction.failure.invalid-url.title':
    "That URL doesn't look right.",
  'onboarding.campaigns.brand-extraction.failure.invalid-url.message':
    'Make sure it starts with https:// and try again.',
  'onboarding.campaigns.brand-extraction.failure.extraction-threw.title':
    "We couldn't extract brand identity from your site.",
  'onboarding.campaigns.brand-extraction.failure.extraction-threw.message':
    'Go back and try again or add your brand details manually.',
  'onboarding.campaigns.brand-extraction.failure.default.title':
    "We couldn't extract your brand data from {{urlDisplay}}.",
  'onboarding.campaigns.brand-extraction.failure.default.message':
    'Try a different URL or add your brand details manually.',
  'onboarding.campaigns.brand-extraction.failure.fallback-prefix':
    "We couldn't extract brand identity from your site.",
  'onboarding.campaigns.brand-extraction.failure.go-back': 'Go back',
  'onboarding.campaigns.brand-extraction.failure.fallback-suffix':
    'and try again or add your brand details manually.',
};
